import { useLocation, useParams } from "react-router-dom";
import CustomButton from "../CustomButton";
import CustomInput from "../CustomInput";
import ModalLayout from "../layouts/ModalLayout";
import { useEffect, useState } from "react";
import attenderApis from "../../api/attenderControllerApis";
import FileUpload from "../common/FileUpload";
import { Attender } from "../../types/attenderType";
import { fetchAttenders } from "../../features/attender-controller/attenderSlice";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";

interface Props {
  onClose?: () => void;
  editData?: Attender;
}

function AddEscort({ onClose }: Props) {
  const { id } = useParams();
  const studentId = Number(id);
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { editData } = location.state || {};
  const [formData, setFormData] = useState({
    fullName: "",
    relation: "",
    mobileNo: "",
    email: "",
    profileUrl: "",
    isVerified: null as boolean | null,
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        fullName: editData.fullName || "",
        relation: editData.relation || "",
        mobileNo: editData.mobileNo || "",
        email: editData.email || "",
        profileUrl: editData.profileUrl || "",
        isVerified: (editData as any).isVerified || false,
      });
    }
  }, [editData]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (editData?.attenderId) {
        await attenderApis.updateAttender(editData.attenderId, {
          ...formData,
          relation: formData.relation.toUpperCase(),
        });
      } else {
        if (!studentId) return;

        await attenderApis.createAttender(studentId, {
          ...formData,
          relation: formData.relation.toUpperCase(),
        });
      }

      if (studentId) {
        // You need dispatch here
        // so import useDispatch in this component
        dispatch(fetchAttenders(studentId));
      }

      onClose?.();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ModalLayout onClose={onClose}>
      <form className="flex flex-col gap-8 w-full" onSubmit={handleSubmit}>
        <div className="grid lg:grid-cols-2 gap-5">
          <CustomInput
            name="fullName"
            label="Escort name"
            type="text"
            placeholder="Enter the name of escort"
            value={formData.fullName}
            onChange={handleInputChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="email"
            label="Email"
            placeholder="Enter email"
            value={formData.email}
            onChange={handleInputChange}
          />

          <CustomInput
            name="relation"
            label="Relationship with child"
            type="text"
            placeholder="Enter the escort's relationship with the child"
            value={formData.relation}
            onChange={handleInputChange}
            inputClassName="w-full"
          />
          <CustomInput
            name="mobileNo"
            label="Mobile number"
            type="text"
            placeholder="Enter escort's mobile number"
            value={formData.mobileNo}
            onChange={handleInputChange}
            inputClassName="w-full"
          />
        </div>
        <div className="flex justify-center">
          <FileUpload
            value={formData.profileUrl}
            onUploadComplete={(url) =>
              setFormData((prev) => ({ ...prev, profileUrl: url }))
            }
            className="w-full h-28 mb-10"
            buttonText="Upload Photo"
          />
        </div>
        <div className="flex flex-col md:flex-row gap-7  md:items-center text-nowrap">
          <label className="text-sm font-semibold text-neutral-400 block">
            Escort’s identity verified?
          </label>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <CustomInput
                type="radio"
                name="isVerified"
                value="true"
                checked={formData.isVerified === true}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    isVerified: e.target.value === "true",
                  }))
                }
                inputClassName="w-3 h-3"
              />
              <span className={`text-sm font-semibold`}>Yes</span>
            </div>

            <div className="flex items-center gap-2">
              <CustomInput
                type="radio"
                name="isVerified"
                value="false"
                checked={formData.isVerified === false}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    isVerified: e.target.value === "true",
                  }))
                }
                inputClassName="w-3 h-3"
              />
              <span className={`text-sm font-semibold `}>No</span>
            </div>
          </div>
        </div>
        <div className="flex justify-end items-end gap-5">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <CustomButton type="submit" color="bg-primary-500" text="Save" />
        </div>
      </form>
    </ModalLayout>
  );
}

export default AddEscort;
